export default __webpack_public_path__ + "static/media/banner-curve.f3cfdc8f.svg";